import { CreateOrganizationFormData } from './types';

export const DEFAULT_VALUES: CreateOrganizationFormData = {
  name: '',
  legalName: '',
  offices: [],
  countries: [],
  isEnterprise: false,
  keyAccountManagers: [],
  locales: [],
  jiraId: '',
  legacyId: '',
  pipedriveId: '',
  admin: {
    email: '',
    phone: ''
  }
};
